export default {
  title: {
    en: 'Thanks for your review!',
  },
  negative: {
    text: {
      en: 'We\'re sorry to hear this scent wasn\'t a fit. Still looking? Take our recommendations to find a scent you\'ll love.',
    },
    buttonTitle: {
      en: 'Go to recommendations',
    },
  },
  positive: {
    text: {
      en: 'By learning more about your scent preferences, we\'ll be able to recommend more fragrances you\'ll love in the future.',
    },
    buttonTitle: {
      en: 'See recommendations',
    },
  },
}
